export default __webpack_public_path__ + "static/media/quality-reach.3069c47d.svg";